import script from "./iniReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./iniReceipt.vue?vue&type=script&setup=true&lang=js"

import "./iniReceipt.vue?vue&type=style&index=0&id=db5476c0&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db5476c0"]])

export default __exports__